<template>
	<div class="container">
		<div class="search-container flex flex-between" ref="tableHeight">
			<div class="flex flex-wrap">
				<el-date-picker class="w240 mb5" format="yyyy-MM-dd" value-format="yyyy-MM-dd" size="small"
					v-model="planDate" type="daterange" :picker-options="pickerOptions" @change="handleSearch()"
					:editable="false" :clearable="true" range-separator="-" start-placeholder="SAP关闭开始日期"
					end-placeholder="SAP关闭结束日期">
				</el-date-picker>
				<el-input v-model.trim="searchFrom.agentName" class="w190 mb5 ml10" size="small" placeholder="客商名称" @keyup.enter.native="handleSearch"
					maxlength="30" clearable>
				</el-input>
				<el-input v-model.trim="searchFrom.agentCode" class="w190 ml10" size="small" placeholder="客商编号" @keyup.enter.native="handleSearch"
					maxlength="20" clearable>
				</el-input>
				<el-input v-model.trim="searchFrom.sapNo" class="w190 ml10" size="small" placeholder="客商SAP编号" @keyup.enter.native="handleSearch"
					maxlength="15" clearable>
				</el-input>
				<el-select v-model="searchFrom.settlementType" class="w190 ml10" size="small" placeholder="请选择结算方式" @change="handleSearch()"
					clearable>
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<el-select v-model="searchFrom.advancesFlag" class="w190 ml10" size="small" placeholder="是否预付款" @change="handleSearch()"
					clearable>
					<el-option label="预付款" value="Y">
					</el-option>
					<el-option label="非预付款" value="N">
					</el-option>
				</el-select>
				<el-select v-model="searchFrom.agentTag1" class="w190 ml10" size="small" placeholder="销售据点分类" @change="handleSearch()"
					clearable>
					<el-option label="分公司" value="分公司"></el-option>
					<el-option label="外仓" value="外仓"></el-option>
					<el-option label="营业所" value="营业所"></el-option>
				</el-select>
				<el-input v-model.trim="searchFrom.agentTag3" class="w190 ml10" size="small" placeholder="客商标签3" @keyup.enter.native="handleSearch"
					maxlength="11" clearable>
				</el-input>
				<el-select v-model="searchFrom.skuId" class="w190 ml10" size="small" placeholder="请选择销售范围" @change="handleSearch()" clearable>
					<el-option v-for="item in skuList" :key="item.skuId" :label="item.skuName" :value="item.skuId"></el-option>
				</el-select>
				<img class="icon-img ml10" src="@/assets/images/search.png" @click="handleSearch()" alt="">
				<el-select
					v-model="selectAttribute"
					class="w190 ml10"
					size="small"
					placeholder="批量调整属性"
				 	v-if="isEdit"
					:disabled="multipleSelection.length > 0 ? false : true">
					<el-option @click.native="handleAttr('1')" label="sku范围" value="1"></el-option>
					<el-option @click.native="handleAutomatic()" label="批量设置自贩价格" value="2"></el-option>
				</el-select>
			</div>
			<div class="operation-box" v-if="isEdit">
				<img class="icon-img" src="@/assets/images/syn.png" @click="setSyn" title="更新客商信息(SAP同步)" alt="">
				<img class="icon-img ml7" src="@/assets/images/merge.png" @click="handleMerge" title="合并" alt="">
				<img class="icon-img ml7" src="@/assets/images/add.png" @click="handleEdit" title="新增" alt="">
			</div>
		</div>
		<div class="table-container">
			<el-table ref="multipleTable" v-if="tableData.length>0" v-el-table-infinite-scroll="tableLoad"
				:data="tableData" :height="height" :cell-style="cellStyle" :row-class-name="tabRowClassName"
				:row-key="(row) => {return row.agentId}"
				:header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333'}"
				@selection-change="handleSelectionChange" border style="width: 100%" @cell-click="editRow">
				<el-table-column type="selection" width="50" :reserve-selection="true" align="center">
				</el-table-column>
				<el-table-column prop="agentCode" width="200" label="客商编号" :show-overflow-tooltip="true" sortable>
				</el-table-column>
				<el-table-column prop="agentName" width="200" label="客商名称" :show-overflow-tooltip="true" fixed sortable>
				</el-table-column>
				<el-table-column prop="agentShortName" width="200" label="客商简称" :show-overflow-tooltip="true" sortable>
				</el-table-column>
				<el-table-column prop="skuNames" width="200" label="销售范围" :show-overflow-tooltip="true" sortable>
				</el-table-column>
				<el-table-column prop="settlementType" width="200" label="结算方式" :show-overflow-tooltip="true" sortable>
					<template slot-scope="scope">
						{{settlementType[scope.row.settlementType]}}
					</template>
				</el-table-column>
				<el-table-column prop="advancesFlag" width="200" label="是否预付款" :show-overflow-tooltip="true" sortable>
					<template slot-scope="scope">
						{{scope.row.advancesFlag=='Y'?"预付款":"非预付款"}}
					</template>
				</el-table-column>
				<el-table-column prop="sapNo" width="200" label="客商SAP编号" :show-overflow-tooltip="true" fixed sortable>
				</el-table-column>
				<el-table-column prop="ncDrawerName" width="200" label="SAP开票名称" :show-overflow-tooltip="true" sortable>
				</el-table-column>
				<el-table-column prop="agentTag1" width="200" label="销售据点分类" :show-overflow-tooltip="true" sortable>
				</el-table-column>
				<!-- <el-table-column prop="agentTag2" width="200" label="客商标签2" :show-overflow-tooltip="true" sortable>
				</el-table-column> -->
				<el-table-column prop="agentTag3" width="200" label="客商标签3" :show-overflow-tooltip="true" sortable>
				</el-table-column>
				<el-table-column prop="createdTime" width="200" label="SAP导入日期" :show-overflow-tooltip="true" sortable>
					<template slot-scope="scope">
						{{ dateFormat(scope.row.createdTime) }}
					</template>
				</el-table-column>
				<el-table-column prop="ncSealflag" width="200" label="SAP关闭日期" :show-overflow-tooltip="true" sortable>
				</el-table-column>
				<el-table-column prop="groupName" width="200" label="组织部门" :show-overflow-tooltip="true" sortable>
				</el-table-column>
			</el-table>
			<el-empty v-else :style="{height:height+'px'}" description="暂无数据"></el-empty>
			<div class="flex flex-between search-container">
					<div class="totalPage">
						当前第<span class="page-active">{{currentNo}}</span>页，共<span class="page-active">{{totalCount}}</span>条数据，共<span class="page-active">{{totalPage}}</span>页
					</div>
				<img class="icon-img" style="vertical-align: middle;" src="@/assets/images/down.png" @click="download"
					title="导出" alt="">
			</div>
		</div>
		<infoAdd ref="infoAdd" @getList="handleSearch"></infoAdd>
		<infoEdit ref="infoEdit" @getList="handleSearch"></infoEdit>
		<mergeMerchants ref="mergeMerchants" @getList="handleSearch"></mergeMerchants>
		<batch ref="batch" :selectAttribute="selectAttribute" @handleBatch="handleBatch" @getList="getList1"></batch>
		<automaticPrice ref="automaticPrice" @handleBatch="handleBatch" @getList="getList1"></automaticPrice>
	</div>
</template>

<script>
	import infoEdit from './components/info-edit.vue'
	import infoAdd from './components/info-add.vue'
	import mergeMerchants from './components/merge-merchants.vue'
	import batch from './components/batch.vue'
	import automaticPrice from './components/automaticPrice.vue'
	import { hasPermission } from '@/utils/permission'
	import { debounce } from '@/utils/debounce'
	import { dateFormat } from '@/utils/common'
	export default {
		name:'info',
		components: {
			infoEdit,
			infoAdd,
			mergeMerchants,
			batch,
			automaticPrice
		},
		data() {
			return {
				searchFrom: {
					agentName: "",
					agentCode: "",
					sapNo: "",
					settlementType: "",
					advancesFlag: "",
					// 销售据点分类
					agentTag1: "",
					// 客商标签3
					agentTag3: "",
					sku: [],
					skuId:"",
				},
				tableData: [],
				titles: [],
				groupTreeDialog: false,
				treeData: [],
				multipleSelection: [],
				options: [
					{
						value: '0',
						label: '现金'
					},
					{
						value: '1',
						label: '账期'
					},
					{
						value: '9',
						label: '自贩'
					},
					{
						value: '2',
						label: '其它'
					}
				],
				settlementType: {
					0: '现金',
					1: '账期',
					2: '其它',
					9: '自贩'
				},
				value: "",
				selectAttribute: "",
				pageNo: 1,
				pageSize: 40,
				height: 500,
				infiniteFlag: false,
				isEdit:false,
				totalPage:"",
				totalCount:"",
				currentNo:"",
				skuList:[],
				// 日期格式化：yyyy-mm-dd
				dateFormat: null,
				// 开始时间结束时间
				planDate: [],
				pickerOptions: {
					onPick: ({ minDate, maxDate }) => {
						// 将第一个选中的日期赋值给 this.min
						this.min = minDate && minDate.getTime()
						// 如果选择了时间段，则清空 this.min
						if (maxDate) {
							this.min = ''
						}
					},
					disabledDate: (time) => {
						let oneMonths = 62 * 24 * 60 * 60 * 1000
						let minDate = this.min - oneMonths
						let maxDate = this.min + oneMonths
						if (this.min !== "") {
							return time.getTime() > maxDate || time.getTime() < minDate
						}
					}
				},
			}
		},
		created() {
			// const end = new Date();
			// const start = new Date();
			// start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
			// this.planDate = [dateFormat(end), dateFormat(end)]
			this.dateFormat = dateFormat;
			this.getList();
			this.getTree();
			if (this.$route.meta.perm) {
				this.isEdit = hasPermission(this.$route.meta.perm);
			}
		},
		mounted() {
			let height = this.$refs.tableHeight.offsetHeight;
			this.height = window.innerHeight - 130 - height;
			this.getSkuList()
		},
		methods: {
			tabRowClassName({
				row,
				rowIndex
			}) {
				let index = rowIndex + 1;
				if (index % 2 == 1) {
					return 'warning-row'
				}
			},
			cellStyle({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex == 1) {
					return 'cursor: pointer;'
				}
			},
				//  sku获取
			getSkuList() {
				let that = this;
				that.$request.post(
						"skuList",
						false, {
							userStatus: 0
						}
					)
					.then((res) => {
						if (res) {
							that.skuList = res.data
						}
					})
			},
			// 表格滚动加载
			tableLoad: debounce(function () {
				this.pageNo++;
				this.getList('scroll');
			}, 100, true),
			// 新增
			handleEdit() {
				this.$refs.infoAdd.init()
			},
			//批量sku调整属性
			handleAttr(val) {
				if (val == 1 || val == 2) {
					this.$refs.batch.init(val, this.multipleSelection)
				}
			},
			// 批量调整属性，自动贩卖机
			handleAutomatic() {
				this.$refs.automaticPrice.init(this.multipleSelection)
			},
			// 合并客商
			handleMerge() {
				this.$refs.mergeMerchants.init()
			},
			// 查看/编辑
			editRow(row, column, cell, event) {
				if (column.label == '客商名称') {
					this.$refs.infoEdit.init(row)
				} else {
					this.$refs.multipleTable.toggleRowSelection(row);
				}
			},
			handleSearch() {
				if (this.tableData.length > 0) {
					this.$refs.multipleTable.clearSelection();
					this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
				}
				this.infiniteFlag = false;
				this.pageNo = 1;
				this.$nextTick(() => {
					this.getList();
				})
			},
			// 批量调整属性后
			getList1() {
				this.selectAttribute = "";
				if (this.tableData.length > 0) {
					this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
				}
				this.infiniteFlag = false;
				this.pageNo = 1;
				this.$nextTick(() => {
					this.getList();
				})
			},
			// 获取列表
			getList(type) {
				if(this.infiniteFlag) {
					return
				}
				let that = this;
				that.$request.post(
						"agentListPage",
						true, {
							pageNo: that.pageNo,
							pageSize: that.pageSize,
							agentName: that.searchFrom.agentName,
							agentCode: that.searchFrom.agentCode,
							sapNo: that.searchFrom.sapNo,
							settlementType: that.searchFrom.settlementType,
							advancesFlag: that.searchFrom.advancesFlag,
							agentTag1: that.searchFrom.agentTag1,
							agentTag3: that.searchFrom.agentTag3,
							skuId: that.searchFrom.skuId,
							dateStart: that.planDate ? that.planDate[0] : "",
							dateEnd: that.planDate ? that.planDate[1] : "",
						}
					)
					.then((res) => {
						if(res) {
							that.infiniteFlag = res.data.totalPage <= that.pageNo;
							if (type == 'scroll') {
								that.tableData = that.tableData.concat(res.data && res.data.list || []);
								that.totalPage=res.data.totalPage
								that.totalCount=res.data.totalCount
								that.currentNo = res.data.pageNo
							} else {
								if (res && res.data.list.length > 0) {
									that.tableData = res.data.list
									that.totalPage=res.data.totalPage
									that.totalCount=res.data.totalCount
									that.currentNo = res.data.pageNo
								} else {
									that.tableData = []
									that.totalPage=0
									that.totalCount=0
									that.currentNo = 0
								}
							}
						}
					})
			},
			// 获取组织树
			getTree() {
				let that = this;
				that.$request.post(
						"tree",
						false, {}
					)
					.then((res) => {
						if (res) {
							that.treeData = res.data
						}
					})
			},
			// groupId回调
			groupIdCallback(val) {
				this.searchFrom.groupIds = val
			},
			// groupName回调
			groupNameCallback(val) {
				this.searchFrom.groupName = val ? val.join(",") : ""
			},
			// 组织树
			showGroupTree() {
				this.groupTreeDialog = true;
				this.$nextTick(() => {
					this.$refs.groupTree.init(this.treeData);
				});
			},
			// 列多选
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			// 删除
			deleteRow() {
				let that = this;
				if (that.multipleSelection.length <= 0) {
					this.$message.error('请先选择!');
					return
				}
				let userIds = []
				that.multipleSelection.forEach(item => {
					userIds.push(item.agentId)
				});
				that.$confirm('是否确认删除？', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'error'
				}).then(() => {
					that.$request.post(
							"agentDelete",
							false, {
								agentIds: userIds,
							}
						)
						.then((res) => {
							if (res) {
								that.$message.success("删除成功！");
								that.handleSearch()
							}
						})
				}).catch(() => {});
			},
			// 同步Nc系统
			setSyn() {
				let that = this;
				// if (that.multipleSelection.length <= 0) {
				// 	this.$message.error('请先选择!');
				// 	return
				// }
				let agentIds = []
				that.multipleSelection.forEach(item => {
					agentIds.push(item.agentId)
				});
				that.$confirm('是否同步选中的客商信息？', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'error'
				}).then(() => {

						that.$request.post(
							"agentsync",
							true, {
								agentIds: agentIds,
							}
						)
						.then((res) => {
							if (res) {
								that.$message.success("同步成功！");
								that.handleSearch()
							}
						})
				}).catch(() => {});
			},
			// 修改批量调整数据值
			handleBatch() {
				this.selectAttribute = '';
			},
			// 导出
			download() {
				let that = this;
				let agentIds = []
				that.multipleSelection.forEach(item => {
					agentIds.push(item.agentId)
				});
				that.$request.post(
						"agentInfoExport",
						true, {
							pageNo: 1,
							pageSize: 50000,
							agentIds:agentIds,
							agentName: that.searchFrom.agentName,
							agentCode: that.searchFrom.agentCode,
							sapNo: that.searchFrom.sapNo,
							settlementType: that.searchFrom.settlementType,
							advancesFlag: that.searchFrom.advancesFlag,
							agentTag1: that.searchFrom.agentTag1,
							agentTag3: that.searchFrom.agentTag3,
							skuId: that.searchFrom.skuId,
							dateStart: that.planDate ? that.planDate[0] : "",
							dateEnd: that.planDate ? that.planDate[1] : "",
						}
					)
					.then((res) => {
						if (res) {
							let downloadURL = res.data
							const linkNode = document.createElement('a');
							linkNode.style.display = 'none';
							linkNode.href = downloadURL;
							document.body.appendChild(linkNode);
							linkNode.click(); //模拟在按钮上的一次鼠标单击
							URL.revokeObjectURL(linkNode.href); // 释放URL 对象
							document.body.removeChild(linkNode);
						}
					})
			},
		},
	}

</script>

<style lang='scss' scoped>
	.container {
		background: #fff;
		box-sizing: border-box;
		margin: 12px 26px 15px 10px;
		// padding-bottom: 20px;

		.el-table {

			// 深度选择器，去除默认的padding
			/deep/ th {
				padding: 0px;
			}

			/deep/ td {
				padding: 5px;
			}

			/deep/ .warning-row {
				background: #F1F1F5;
			}
			/deep/ th .el-table__cell{
				padding: 0 !important;
			}
		}
	}

	.red {
		width: 50px;
		height: 20px;
		background: #D9001B;
	}

	.blue {
		width: 50px;
		height: 20px;
		background: #02A7F0;
	}

	.search-container {
		padding: 8px;
	}

	.operation-box {
		min-width: 110px;
	}

	.w190 {
		width: 150px !important;
	}

</style>
